import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

export const getSSLLIst=createAsyncThunk('getSSLLIst',async (_,{rejectWithValue})=>{
    try {
        const response = await instance.get("/crm/ssl/ssl-list");
        return response?.data
    } catch (error) {
        return rejectWithValue(error.response)
    }

})


export const AddSSL=createAsyncThunk('AddSSL',async (data,{rejectWithValue})=>{
    try {
       
        
        const response = await instance.post("/crm/ssl/add-ssl",data);
        return response?.data
    } catch (error) {
        return rejectWithValue(error.response)
    }

})


export const SSLSlice = createSlice({
    name: "SSLSlice",
     initialState : {
        data: null,
        sslDetail: null,
        loading: false,
        error: null,
    
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getSSLLIst.pending, (state) => {
            state.loading = true;
            state.data = null;
            state.response = null;
        });
        builder.addCase(getSSLLIst.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload;
            state.sslDetail = action?.payload?.sslDetail;
        });
        builder.addCase(getSSLLIst.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload
        });
    }
})

export default SSLSlice.reducer